<template>
  <div class="b-menu-item-bubble" :class="classes.container"
       @mouseenter="setHover"
       @mouseleave="unsetHover">

    <div class="test-container" :style="[styles.size]">
      <div class="b-menu-item-bubble__bubble" :class="classes.bubble" @click="onClick" :style="[styles.backgroundColor]">
        <div class="b-menu-item-bubble__content-component-container">

          <component :is="contentComponent" :item="renderItem" :edit-mode="edit" :has-hover="hover"></component>

        </div>
      </div>

      <component class="b-menu-item-bubble__label" :is="labelComponent" :item="renderItem"></component>

      <b-menu-item-bubble-actions :edit-mode="edit"
                                  :show="showActions"
                                  @click:delete="onDelete"
                                  @click:edit="startEditMode"
                                  @click:close-edit="closeEditMode"
                                  @click:save="onSave">
      </b-menu-item-bubble-actions>
    </div>
  </div>
</template>

<script>
import BMenuItemBubbleActions from './b-menu-item-bubble-actions'

import DraggableFactory, { Types, Directions } from '../util/DragAndDrop'
import StoreHelper from '../store/helper'

import EventBus, { Events } from '../event-bus'
import _ from 'lodash'

export default {
  name: 'b-menu-item-bubble',
  components: {
    BMenuItemBubbleActions
  },
  props: {
    item: {
      type: Object
    }
  },
  data () {
    return {
      contentComponent: StoreHelper.getMenuItemBubbleContentComponent(),
      labelComponent: StoreHelper.getMenuItemBubbleLabelComponent()
    }
  },
  activated () {
    if (StoreHelper.isDraggableBubblesEnabled()) {
      DraggableFactory.register(Types.DRAGGABLE, null, this.$el, this)
      if (!this.isDroppableDisabled) {
        DraggableFactory.register(Types.DROPPABLE_BUBBLE, Directions.DOWNWARDS, this.$el.querySelector('.b-menu-item-bubble__bubble'), this)
      }
    }
  },
  mounted () {
    if (StoreHelper.isDraggableBubblesEnabled()) {
      DraggableFactory.register(Types.DRAGGABLE, null, this.$el, this)

      if (!this.isDroppableDisabled) {
        DraggableFactory.register(Types.DROPPABLE_BUBBLE, Directions.DOWNWARDS, this.$el.querySelector('.b-menu-item-bubble__bubble'), this)
      }
    }
  },
  methods: {
    onClick () {
      if (!StoreHelper.isEditInProgress()) {
        StoreHelper.setHoverItem(null)
        this.$emit('click', this.item)
      }
    },
    onDelete () {
      EventBus.$emit(Events.B_MENU_ITEM_DELETE, this.item)
    },

    startEditMode () {
      EventBus.$emit(Events.B_MENU_ITEM_EDIT, this.item)
      StoreHelper.setEditItem(this.item)
    },
    closeEditMode () {
      StoreHelper.setEditItem(null)
    },

    onSave () {
      EventBus.$emit(Events.B_MENU_ITEM_SAVE, StoreHelper.getEditItem())
      this.closeEditMode()
    },

    setHover () {
      StoreHelper.setHoverItem(this.item)
    },
    unsetHover: () => { StoreHelper.setHoverItem(null) }
  },
  computed: {
    classes () {
      return {
        container: {
          'b-menu-view__menu-item-bubble--hover': this.hover,
          'b-menu-view__menu-item-bubble--edit': this.edit
        },
        bubble: StoreHelper.getMenuItemBubbleDefaultClasses()
      }
    },
    styles () {
      return {
        size: { width: this.size, height: this.size },
        backgroundColor: { backgroundColor: this.backgroundColor }
      }
    },
    renderItem () {
      return this.edit
        ? StoreHelper.getEditItem()
        : this.item
    },
    size () {
      return (_.isEqual(this.item.size, 'small') ? this.sizes.small : this.sizes.default) + 'px'
    },
    sizes () {
      // TODO: Add to configuration or outsource
      return {
        'default': StoreHelper.getMenuItemBubbleSize(),
        'small': StoreHelper.getMenuItemBubbleSize() * 0.8
      }
    },
    hover () {
      return StoreHelper.isHoverItem(this.item)
    },
    edit () {
      return StoreHelper.isEditItem(this.item)
    },
    showActions () {
      return StoreHelper.getShowActions() && this.hover
    },
    backgroundColor () {
      return this.item.colorDefinition ? this.item.colorDefinition.hex : null
    },
    isDroppableDisabled () {
      return _.get(this.item, 'disableDroppable', false)
    }
  },
  deactivated () {
    if (StoreHelper.isDraggableBubblesEnabled()) {
      DraggableFactory.unregister(this.$el)
    }
  },
  beforeDestroy () {
    if (StoreHelper.isDraggableBubblesEnabled()) {
      DraggableFactory.unregister(this.$el)
    }
  }
}
</script>

<style lang="scss" scoped>
  .b-menu-item-bubble {
    position: absolute;
    top: 50%;
    left: 50%;

    &__bubble {
      border-radius: 50%;
      background-color: #63B32E;
      cursor: pointer;
      padding: 15%;
      height: 80%;
      width: 80%;
      transition: all 200ms cubic-bezier(0, 0, 0.57, 1.57); // TODO: Outsource?
      pointer-events: all;
    }

    &__content-component-container {
      padding: 15%;
      height: 100%;
      width: 100%;
    }

    &:not(.b-menu-view__menu-item-bubble--edit) &__content-component-container {
      pointer-events: none;
    }

    &__label {
      position: absolute;
      bottom: 0;
      transform: translateY(100%);
      text-align: center;
    }
  }

  .test-container {
    margin: -50%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
